import AbstractComponent from "./abstract-component";

/**
 * @param String data
 * @param {Object} options
 *  pageBreak: null (default) | "before" | "after"
 */
class ContentTitle extends AbstractComponent {
  render() {
    const {pageBreak, colSpan} = this.options;

    return {
      text: `${this.data}`,
      style: 'sectionTitle',
      margin: [0, 0, 0, 16],
      pageBreak,
      colSpan
    }
  }
}

export default ContentTitle.asFunction();
